/*
 * "Other listings of this model" on the product page.
 *
 * The catalogue carries one listing per colour/condition, so a single model can appear a
 * dozen times -- and a sold-out listing is often a dead end while the same model sits in
 * stock under another listing. This asks Shopify's predictive search for the model at page
 * load, so availability is always live and there is nothing stored to go stale.
 *
 * Search is fuzzy ("Nanuk 915" also returns 910 and 925). Near models are kept as
 * cross-sell but shown under their own heading naming only the brand, so the page never
 * claims a 910 is a 915.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    var root = document.querySelector('[data-same-model]');
    if (!root) return;

    var title = root.getAttribute('data-product-title') || '';
    var handle = root.getAttribute('data-product-handle') || '';
    var vendor = (root.getAttribute('data-product-vendor') || '').trim();
    var available = root.getAttribute('data-available') === 'true';

    // Ordered most specific first: a SKB "3i-2015-7" must not be read as a bare "2015".
    var PATTERNS = [
      /\b(3i-?\s?\d{4}-?\s?\d{1,2})\b/i,      // SKB iSeries
      /\b(\d?skb-[a-z0-9-]+)\b/i,             // SKB rSeries part numbers
      /\b(i\s?m\s?\d{4}[a-z]{0,4})\b/i,       // Pelican Storm iM2700
      /\bnanuk\s?(\d{3,4})\b/i,
      /\b(v\d{3}[a-z0-9]{0,3})\b/i,           // Vault / Valkyrie
      /(?:^|[^\dx.])(\d{4})(?![\dx.])/i       // Pelican 1620, never part of a dimension
    ];

    function detectModel(text) {
      for (var i = 0; i < PATTERNS.length; i++) {
        var m = text.match(PATTERNS[i]);
        if (m) return m[1];
      }
      return null;
    }

    function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }

    var model = detectModel(title);
    if (!model) return; // dimension-named surplus cases have no model to group by

    var key = norm(model);
    var hasBrand = vendor && vendor.toLowerCase() !== 'thecaseplace.com';
    var brand = hasBrand ? vendor : '';
    var label = (hasBrand ? vendor + ' ' : '') + model.toUpperCase().replace(/\s+/g, '');
    var query = (hasBrand ? vendor + ' ' : '') + model;

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=10', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var found = ((((data || {}).resources || {}).results || {}).products) || [];
        var others = found.filter(function (p) { return p && p.url && p.handle !== handle; });

        var exact = others.filter(function (p) { return norm(p.title).indexOf(key) !== -1; });
        var near  = others.filter(function (p) { return norm(p.title).indexOf(key) === -1; });

        var exactIn = exact.filter(function (p) { return p.available; });
        var nearIn  = near.filter(function (p) { return p.available; });
        if (!exactIn.length && !nearIn.length && !exact.length) return;

        render(exactIn, nearIn, exact.length);
      })
      .catch(function () { /* a failed lookup simply shows nothing */ });

    function card(p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      return '<a class="same-model__card" href="' + p.url + '">' +
               (img ? '<img class="same-model__img" src="' + img + '&width=200" alt="" loading="lazy" width="80" height="80">' : '') +
               '<span class="same-model__meta">' +
                 '<span class="same-model__name">' + escapeHtml(p.title) + '</span>' +
                 '<span class="same-model__price">' + (p.price ? formatMoney(p.price) : '') + '</span>' +
               '</span>' +
             '</a>';
    }

    function grid(list) {
      return '<div class="same-model__grid">' + list.map(card).join('') + '</div>';
    }

    function heading(text, sub) {
      return '<h2 class="same-model__title h4' + (sub ? ' same-model__title--sub' : '') + '">' + text + '</h2>';
    }

    function render(exactIn, nearIn, exactCount) {
      var html = '';
      var slots = 4;

      if (exactIn.length) {
        var shown = exactIn.slice(0, slots);
        if (!available) {
          html += heading('Sold out &mdash; but ' + exactIn.length + ' other ' + escapeHtml(label) +
                          (exactIn.length === 1 ? ' listing is' : ' listings are') + ' in stock');
        } else {
          html += heading('Other ' + escapeHtml(label) + ' listings in stock');
        }
        html += grid(shown);
        slots -= shown.length;
      }

      // Near models are a different model, so name only the brand here.
      if (slots > 0 && nearIn.length) {
        var nearShown = nearIn.slice(0, slots);
        var nearTitle = brand ? 'Other ' + escapeHtml(brand) + ' in stock' : 'Similar cases in stock';
        if (!exactIn.length && !available) {
          nearTitle = brand ? 'Sold out &mdash; other ' + escapeHtml(brand) + ' in stock'
                            : 'Sold out &mdash; similar cases in stock';
        }
        html += heading(nearTitle, exactIn.length > 0);
        html += grid(nearShown);
      }

      if (!html && exactCount) {
        html += heading('Other ' + escapeHtml(label) + ' listings');
      }
      if (!html) return;

      // A "shop all" pointing at a single other listing is noise -- the card is right there.
      if (exactCount > 1) {
        html += '<a class="same-model__all link underlined-link" href="/search?q=' +
                encodeURIComponent(query) + '&type=product">Shop all ' + escapeHtml(label) +
                ' (' + exactCount + ')</a>';
      }

      root.innerHTML = html;
      root.hidden = false;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function formatMoney(cents) {
      if (typeof cents === 'string' && cents.indexOf('$') !== -1) return escapeHtml(cents);
      var n = parseFloat(cents);
      if (isNaN(n)) return '';
      if (n > 1000) n = n / 100;
      return '$' + n.toFixed(2);
    }
  });
})();
